<template>
  <div class="login">
    <div class="Slogan">
      <img src="../../assets/img/logo.png" alt="掌大师">
      <div class="SloganText">
        <h2 class="Slogan-head-title">掌大师ERP管理</h2>
        <h2 class="Slogan-head-text">帮您轻松管理每一天</h2>
      </div>
    </div>
    <div class="form-content">
        <p class="form-content-title">账号登录</p>
        <Form class="form-info" >
          <FormItem class="FormItem">
            <img src="../../assets/img/phone-portrait.png">
            <input type="text" class="form-input" v-model.trim="formInline.account"  placeholder="输入账号">
          </FormItem>
          <FormItem class="FormItem">
            <img src="../../assets/img/password.png">
            <input  type="password" v-model.trim="formInline.password"  class="form-input" placeholder="输入密码">
          </FormItem>
          <FormItem>
            <Row class="forget">
              <Col span="12">
                 <!--忘记密码--> &nbsp;
              </Col>
              <Col span="12" align="right">
                <Checkbox v-model="formInline.single" size="large" style="font-size: 18px">记住密码</Checkbox>
              </Col>
            </Row>
          </FormItem>
          <FormItem style="margin-bottom: 10px">
            <Button size="large" long class="submit-form" @click="submitForm()" >登录</Button>
          </FormItem>
          <!--<FormItem class="signIn">
            <p><router-link to="/register">暂无帐号，立即注册 <Icon type="ios-arrow-forward" /></router-link></p>
          </FormItem>-->
        </Form>
    </div>
    <div class="Company">
      <p>客服电话:400-801-6580</p>
      <p>公司官网: <a href="http://www.tangyingchina.com/" target="_blank">www.tangyingchina.com</a></p>
      <p @click="Agreementdiag=true" style="cursor: pointer">登录即代表同意《掌大师用户服务协议》</p>
    </div>



    <Modal
            v-model="Agreementdiag"
            title="掌大师用户服务协议"
            width="80%"
            >
      <div style="line-height: 26px">
        <div>
          欢迎阅读掌大师进销存服务条款协议(下称“本协议”)。本协议阐述之条款和条件适用于您使用上海唐赢科技有限公司（以下简称“掌大师进销存”或“本公司”）所提供的各种工具和服务(下称“服务”)。
        </div>
        <div>
          1. 接受条款
        </div>
        <div>
          以任何方式使用掌大师进销存服务即表示您同意自己与掌大师进销存订立本协议，且您将受本协议的条款和条件(“条款”) 约束。掌大师进销存可随时自行决定修订本协议“条款”。您应在条款修改后第一次登录时仔细阅读修订后的“条款”，如您对修订后的条款有异议，您有权选择停止继续使用“服务”；一旦您继续使用“服务”，则表示您已接受经修订的“条款”，当您与掌大师进销存发生争议时，应以最新的服务协议为准。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。除非经掌大师进销存的授权高层管理人员签订书面协议，本协议不得另行作出修订。
        </div>
        <div>
          2. 谁可使用掌大师进销存
        </div>
        <div>
          “服务”仅供能够根据相关法律订立具有法律约束力的合约的个人或公司、个体工商户等形式的企业使用。因此，您的年龄必须在十八周岁或以上（如使用主体为企业，您确保已征得企业授权），才可使用本公司服务。如不符合本项条件，请勿使用“服务”。掌大师进销存可随时自行全权决定拒绝向任何人士提供“服务”。“服务”不会提供给被暂时或永久中止资格的掌大师进销存用户。
        </div>
        <div>3. 收费</div>
        <div>
          本公司保留在根据第1条通知您后，收取“服务”费用的权利。您因进行交易、向本公司获取有偿服务或接触本公司服务器而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。本公司保留在无须发出书面通知，仅在掌大师进销存公示的情况下，暂时或永久地更改或停止部分或全部“服务”的权利。
        </div>

        <div>4. 您的资料和供买卖的物品</div>
        <div>
          “您的资料”包括您在注册、交易或列举物品过程中、在任何公开信息场合或通过任何电子邮件形式，向本公司或其他用户提供的任何资料，包括数据、文本、软件、音乐、声响、照片、图画、影像、词句或其他材料。您应对“您的资料”负全部责任，而本公司仅作为您在网上发布和刊登“您的资料”的被动渠道。但是，倘若本公司认为“您的资料”可能使本公司承担任何法律或道义上的责任，或可能使本公司 (全部或部分地) 失去本公司的互联网服务供应商或其他供应商的服务，或您未在掌大师进销存规定的期限内登录或再次登录网站，则本公司可自行全权决定对“您的资料”采取本公司认为必要或适当的任何行动，包括但不限于删除该类资料。您特此保证，您对提交给掌大师进销存的“您的资料”拥有全部权利，包括全部版权。
          您确认，掌大师进销存没有责任去认定或决定您提交给本公司的资料哪些是应当受到保护的，对享有“服务”的其他用户使用“您的资料”，本公司也不必负责。
        </div>
        <div>4.1 注册义务</div>
        <div>
          如您在掌大师进销存注册，您同意：(a) 根据用户注册页面所刊载的会员资料表格的要求，提供关于您或贵公司、企业的真实、准确、完整和反映当前情况的资料；(b) 维持并及时更新会员资料，使其保持真实、准确、完整和反映当前情况。倘若您提供任何不真实、不准确、不完整或不能反映当前情况的资料，或掌大师进销存有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，掌大师进销存有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对“服务”(或其任何部份) 以任何形式使用。如您代表一家企业或其他法律主体在本公司登记，则您声明和保证，您有权使该公司或其他法律主体受本协议“条款”约束。您同意，掌大师进销存可向您提交的注册信息中包含的电话、手机号码，电子邮箱发送商业类广告信息。
        </div>
        <div>4.2 会员注册名、密码和保密</div>
        <div>
          在登记过程中，您将选择会员注册名和密码。您须自行负责对您的会员注册名和密码保密，且须对您在会员注册名和密码下发生的所有活动承担责任。您同意：(a) 如发现任何人未经授权使用您的会员注册名或密码，或发生违反保密规定的任何其他情况，您会立即通知掌大师进销存；及 (b) 确保您在每个上网时段结束时，以正确步骤离开网站或客户端。掌大师进销存不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。
        </div>
        <div>4.3 关于您的资料的规则</div>
        <div>
          您同意，“您的资料”和您供在掌大师进销存上交易的任何“物品”（泛指一切可供依法交易的、有形的或无形的、以各种形态存在的某种具体的物品，或某种权利或利益，或某种票据或证券，或某种服务或行为。本协议中“物品”一词均含此义） a. 不会有欺诈成份，与售卖伪造或盗窃无涉。 b. 不会侵犯任何第三者对该物品享有的物权，或版权、专利、商标、商业秘密或其他知识产权，或隐私权、名誉权。 c. 不会违反任何法律、法规、条例或规章 (包括但不限于关于规范出口管理、贸易配额、保护消费者、不正当竞争或虚假广告的法律、法规、条例或规章)。 d. 不会含有诽谤（包括商业诽谤）、非法恐吓或非法骚扰的内容。 e. 不会含有淫秽、或包含任何儿童色情内容。 f. 不会含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序。 g. 不会直接或间接与下述各项货物或服务连接，或包含对下述各项货物或服务的描述：(i) 本协议项下禁止的货物或服务；或 (ii) 您无权连接或包含的货物或服务。此外，您同意不会：(h) 在与任何连锁信件、大量胡乱邮寄的电子邮件、滥发电子邮件或任何复制或多余的信息有关的方面使用“服务”；(i) 未经其他人士同意，利用“服务”收集其他人士的电子邮件地址及其他资料；或 (j) 利用“服务”制作虚假的电子邮件地址，或以其他形式试图在发送人的身份或信息的来源方面误导其他人士。
        </div>
        <div>4.4 被禁止物品</div>
        <div>
          您不得在本公司网站公布或通过本公司网站买卖：(a) 可能使本公司违反任何相关法律、法规、条例或规章的任何物品；或 (b) 掌大师进销存认为应禁止或不适合通过本网站买卖的任何物品。
        </div>
        <div>5. 您授予本公司的许可使用权</div>
        <div>
          您授予本公司独家的、全球通用的、永久的、免费的许可使用权利 (并有权在多个层面对该权利进行再授权)，使本公司有权(全部或部份地) 使用、复制、修订、改写、发布、翻译、分发、执行和展示"您的资料"或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将"您的资料"纳入其他作品内。
          在不透露单个用户隐私资料的前提下，本公司及关联公司、合作伙伴有权对整个用户数据库进行推演、计算、分析、梳理、挖掘应用，并在此基础上对用户数据库进行商业上的利用。我们保证不对外公开或向第三方提供可能体现出单个用户的信息资料及用户在使用网络服务时存储在我们处的非公开内容。
        </div>
        <div>6. 隐私</div>
        <div>
          尽管有第5条所规定的许可使用权，掌大师进销存将仅根据本公司的隐私声明使用“您的资料”。本公司隐私声明的全部条款属于本协议的一部份，因此，您必须仔细阅读。请注意，您一旦自愿地在掌大师进销存交易地点披露“您的资料”，该等资料即可能被其他人士获取和使用。
        </div>
        <div>7. 终止或访问限制</div>
        <div>
          您同意，在掌大师进销存未向您收费的情况下，掌大师进销存可自行全权决定以任何理由 (包括但不限于掌大师进销存认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事，或您在超过90天的时间内未以您的账号及密码登录网站) 终止您的“服务”密码、账户 (或其任何部份) 或您对“服务”的使用，并删除和丢弃您在使用“服务”中提交的 “您的资料”。您同意，在掌大师进销存向您收费的情况下，掌大师进销存应基于合理的怀疑且经电子邮件通知的情况下实施上述终止服务的行为。掌大师进销存同时可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。您同意，根据本协议的任何规定终止您使用“服务”之措施可在不发出事先通知的情况下实施，并承认和同意，掌大师进销存可立即使您的账户无效，或撤销您的账户以及在您的账户内的所有相关资料和档案，和/或禁止您进一步接入该等档案或“服务”。账号终止后，掌大师进销存没有义务为您保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，掌大师进销存不会就终止您接入“服务”而对您或
          任何第三者承担任何责任。第5、9、10、11各条应在本协议终止后继续有效。
        </div>
        <div>8. 违反规则会有什么后果</div>
        <div>
          在不限制其他补救措施的前提下，发生下述任一情况，本公司可立即发出警告，暂时中止、永久中止或终止您的会员资格，删除您的任何现有数据信息，以及您在网站上展示的任何其他资料：(i) 您违反本协议；(ii) 本公司无法核实或鉴定您向本公司提供的任何资料；或 (iii) 本公司相信您的行为可能会使您、本公司用户或通过本公司或本公司网站提供服务的第三者服务供应商发生任何法律责任。在不限制任何其他补救措施的前提下，倘若发现您从事涉及本公司网站的诈骗活动，掌大师进销存可暂停或终止您的账户。
        </div>
        <div>10. 责任范围</div>
        <div>
          您明确理解和同意，掌大师进销存不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿 (无论掌大师进销存是否已被告知该等损害赔偿的可能性)：(i) 使用或未能使用“服务”；(ii) 因通过或从“服务”购买或获取任何货物、样品、数据、资料或服务，或通过或从“服务”接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用；(iii) 未经批准接入或更改您的传输资料或数据；(iv) 任何第三者对“服务”的声明或关于“服务”的行为；或 (v) 因任何原因而引起的与“服务”有关的任何其他事宜，包括疏忽。
        </div>
        <div>11.争议解决</div>
        <div>
          您同意，如双方在产品使用过程中发生争议的，可通过友好协商进行解决，协商无法解决的，可向上海市仲裁委员会提起仲裁。
        </div>
      </div>
    </Modal>





  </div>
</template>
<script>
  import encrypt from '@/common/encrypt';
  export default {
    components: {},
    data () {
      return {
        formInline: {
          account: '',
          password: '',
          single: false,

        },
        Agreementdiag:false
      }
    },
    mounted: function() {
      //DOM更新完后再请求数据
    },
    created: function() {
      //DOM更新完之前请求数据
      this.formInline.account = localStorage.getItem("rememberTel");//回显电话
      var getIsRemember = localStorage.getItem("isRemember");
      if(getIsRemember=="true"){
        let getLocalPass = localStorage.getItem("rememberPass");
        this.formInline.password = encrypt.Decrypt(getLocalPass, "3019")
        this.formInline.single = true;
      }
    },
    methods: {

      submitForm() {
        let postData = {
          account:this.formInline.account,
          password:this.formInline.password
        };

        this.$Api.adminLogin(postData).then(res => {
          if( res.code == 200 ){
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("adminUser",JSON.stringify( res.data.admin));
            localStorage.setItem("rememberTel", this.formInline.account);

            /* 存储广告时间 */
            sessionStorage.setItem("spaceTime",  JSON.stringify(res.data.spaceTime));
            sessionStorage.setItem("typeCode",  JSON.stringify(res.data.typeCode));

            sessionStorage.setItem("access",  JSON.stringify(res.data.admin.role));
            sessionStorage.setItem("rememberPass", encrypt.Encrypt(this.formInline.password, "3019"));
            if(this.formInline.single){
              localStorage.setItem("isRemember", true);
              localStorage.setItem("rememberPass", encrypt.Encrypt(this.formInline.password, "3019"));
            }else {
              localStorage.setItem("isRemember", false);
              localStorage.removeItem('rememberPass')
            }

            if(res.data.admin.type==1){
              this.$Message.info('登录成功');
              this.$router.push('/main')
            }else {
              this.$Api.getisNotPrintlist({
                cid: res.data.admin.cid,
                 id:  res.data.admin.sid,
              }).then(data => {
                if(data.data.isgeneralwarehouse=='Y'){
                  this.$Message.info('店铺服务中的员工暂时无法登录，请先到手机端登录');
                   return
                }else {
                  this.$router.push('/content')
                }
              });

            }
          }else if( res.code == 400 ){
            this.$Message.info(res.msg);
          }
        }).catch(err=>{
          this.$Message.info(err.msg);
        });
      },
    }
  }
</script>


<style  lang="scss" scoped>
  .login{
    width: 100%;
    height: 100%;
    background: url("../../assets/img/loginbg.png") no-repeat;
    background-size: 90% 70%;
    position: relative;
  }
  .Slogan{
    width: 500px;
    position: absolute;
    top: 40%;
    left: 200px;
    color: #ffffff;
    font-weight: normal;
    img{
      display: inline-block;
      margin-right: 20px;
    }
    .SloganText{
      display: inline-block;
      position: relative;
      top: -5px;
      .Slogan-head-title{
        font-size: 36px;
      }
      .Slogan-head-text{
        font-size: 32px;
      }
    }
  }
  .form-content{
    position: absolute;
    right: 51px;
    top: 50%;
    margin-top: -233px;
    .form-content-title{
      height: 36px;
      padding-left: 20px;
      font-family: SimHei;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #fefeff;
    }
    .form-info{
      width: 490px;
      background-color: #ffffff;
      box-shadow: 0px 10px 40px 0px
      rgba(61, 111, 226, 0.4);
      border-radius: 40px;
      padding: 50px;
      .FormItem{
        height: 60px;
        position: relative;
        img{
          position: absolute;
          left: 10px;
          top: 15px;
          width:20px
        }
        .form-input{
          width: 100%;
          height:60px;
          border: 0;
          font-size: 16px;
          padding-left: 55px;
          border-bottom: 1px solid #d9d9d9;
        }

      }
    }
  }
  .forget{
    font-size: 18px;
  }
  .submit-form{
    height: 40px;
    background-color: #608efc;
    box-shadow: 0px 5px 10px 0px
    rgba(96, 142, 251, 0.6);
    border-radius: 10px;
    font-size: 16px;
    color: #ffffff;
  }
  .signIn{
      text-align: center;
      color: #608efc;
    p{
      font-size: 18px;
      cursor: pointer;
    }

  }
  .Company{
    position: absolute;
    bottom: 60px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #3d6fe0;
    line-height: 30px;
    width: 590px;
    text-align: center;
  }
</style>